import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { useDispatch, useSelector } from "react-redux";
import {
  getAdminFaqs,
  deleteFaq,
  clearErrors,
} from "../../../actions/faqActions";
import { FAQ_DELETE_RESET } from "../../../constants/faqConstants";

import Loader from "../../Loader";

const ListFAQs = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const handleDeleteFAQ = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteFaq(id));
            // Removed the immediate call to getAdminFaqs as it won't work properly
            // The list will be refreshed in the useEffect below when isDeleted becomes true
          },
        },
        {
          label: "No",
          onClick: () => alert.error("No data deleted"),
        },
      ],
    });
  };

  // Fetch FAQs on component mount and when isDeleted changes
  useEffect(() => {
    dispatch(getAdminFaqs());
    console.log("Dispatched getAdminFaqs");
  }, [dispatch]);

  const { faqs, loading, error } = useSelector((state) => state.adminFaqs);
  const { isDeleted, loading: deleteLoading } = useSelector(
    (state) => state.faq
  );

  // Add debugging console logs
  useEffect(() => {
    console.log("AdminFaqs state:", faqs);
    console.log("Loading state:", loading);
    console.log("Error state:", error);
    console.log("isDeleted state:", isDeleted);
  }, [faqs, loading, error, isDeleted]);

  // Handle errors and refresh list after delete
  useEffect(() => {
    if (error) {
      clearErrors();
      return alert.error(error);
    }

    if (isDeleted) {
      alert.success("FAQ deleted successfully");
      dispatch(getAdminFaqs()); // Refresh the list after successful deletion
      dispatch({ type: FAQ_DELETE_RESET });
    }
  }, [dispatch, isDeleted, error, alert]);

  return (
    <Fragment>
      {loading || deleteLoading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Manage
                <small>FAQs</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li className="active">FAQs</li>
              </ol>
            </section>

            <section className="content">
              <div className="row">
                <div className="col-xs-12">
                  <div className="box">
                    <div className="box-header">
                      <h3 className="box-title">FAQs</h3>
                      <div className="box-tools">
                        <Link
                          to={"/admin/faq/new"}
                          className="btn btn-success btn-sm"
                        >
                          + Add FAQ
                        </Link>
                      </div>
                    </div>
                    <div className="box-body table-responsive no-padding">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Question</th>
                            <th>Answer</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <Loader />
                          ) : faqs !== undefined && faqs.length ? (
                            faqs.map((item) => (
                              <tr key={item._id}>
                                <td>
                                  {item.question.length > 60
                                    ? `${item.question.substring(0, 60)}...`
                                    : item.question}
                                </td>
                                <td>
                                  {item.answer.length > 100
                                    ? `${item.answer.substring(0, 100)}...`
                                    : item.answer}
                                </td>
                                <td>
                                  {item.status === true && (
                                    <span className="badge bg-green">
                                      Active
                                    </span>
                                  )}
                                  {item.status === false && (
                                    <span className="badge bg-yellow">
                                      InActive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <Link
                                    to={`/admin/faq/${item._id}`}
                                    className="btn btn-success btn-sm"
                                    title="Edit"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Link>
                                  &nbsp;
                                  <a
                                    className="btn btn-danger btn-sm"
                                    title="Delete"
                                    onClick={() => handleDeleteFAQ(item._id)}
                                    key={item._id}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </a>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4">No records found</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListFAQs;
